import { WISHLIST_CHANGE_QUANTITY, WISHLIST_UPDATE, WISHLIST_ADD_TO_CART } from '../Actions/WishList.action';
 
export const wishlist = (state = {}, action) => {
    switch (action.type) {
        case WISHLIST_CHANGE_QUANTITY:
            return {
                ...state,
                items: state.items.map(
                    (wish) =>
                        (wish.articleNumber === action.articleNumber) ? { ...wish, quantity: action.quantity } : wish),
 
            };
        case WISHLIST_UPDATE :
            return {
                ...state,
                quantity: action.quantity
            };
        case WISHLIST_ADD_TO_CART:
            return {
                ...state,
                payload: action.payload
            };
        default:
            return state;
    }
}